import React, { useEffect } from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FileCopy } from '@material-ui/icons';
import GetAppIcon from '@material-ui/icons/GetApp';
import _e from 'common/localeUtil';
import { MESSAGE_TYPES } from '../utils';
import { DEFAULT_EBOOK_URL } from '../constants';

const useStyles = makeStyles((theme) => ({
	wrapperStyle: {
		marginBottom: theme.spacing(1),
		paddingRight: theme.spacing(1),
		paddingTop: '0.5rem',
		paddingBottom: '0.5rem',
		'& .section-title': {
			marginBottom: theme.spacing(1),
		},
	},
	form: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'stretch',
		border: `1px solid #365275`,
		paddingLeft: theme.spacing(1),
		paddingBottom: theme.spacing(0),
		'& .error': {
			display: 'none',
		},
	},
	formError: {
		color: '#ff453a',
	},
	copyToClipboard: {
		margin: '0 10px',
		backgroundColor: theme.palette.primary['400'],
	},
	urlStyle: {
		display: 'flex',
		flex: 1,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		lineClamp: 1,
		'-webkit-line-clamp': 1,
		textOverflow: 'ellipsis',
		minHeight: 30,
		alignItems: 'center',
		fontWeight: '1rem',
	},
	submitButton: {
		background: 'none',
		color: 'white !important',
	},
	iconStyle: {
		width: 30,
		height: 30,
		minWidth: 0,
		borderRadius: 0,
		margin: 0,
		borderLeft: '1px solid #365275',
		background: theme.palette.primary['100'],
		color: theme.palette.text.primary,
		'&:hover': {
			background: theme.palette.primary['200'],
		},
	},
}));

const EditorLeftPanelURLEbookIntro = () => {
	const classes = useStyles();
	const showMessage = useStoreActions((actions) => actions.showMessage.showMessage);
	const { final_s3_url: finalS3Url = DEFAULT_EBOOK_URL } = useStoreState(
		(state) => state.template.ebook,
	);

	useEffect(() => {}, []);

	const doCopy = () => {
		window.gm_track(`Copy ebook intro url clicked`, { ebookIntroUrl: finalS3Url });
		showMessage({ text: _e('link_copied'), type: MESSAGE_TYPES.LINKCOPIED });
	};

	const downloadEbookIntro = () => {
		window.gm_track(`Download ebook intro clicked`, { ebookIntroUrl: finalS3Url });
		window.open(finalS3Url);
	};

	// console.log('Full Website URL', fullWebsiteURL);
	const buttonDisabled = finalS3Url?.includes('Generating');
	return (
		<div className={classes.wrapperStyle}>
			{/*<div className="section-title">URL</div>*/}
			<div className={classes.form}>
				<div className={classes.urlStyle}>{finalS3Url}</div>
				<CopyToClipboard text={finalS3Url} onCopy={doCopy}>
					<Button
						onCopy={doCopy}
						classes={{ root: classes.iconStyle }}
						disabled={buttonDisabled}
					>
						<FileCopy style={{ width: 15, height: 15 }} />
					</Button>
				</CopyToClipboard>
				<Button
					id={`download-ebookintro-button`}
					onClick={downloadEbookIntro}
					classes={{ root: classes.iconStyle }}
					disabled={buttonDisabled}
				>
					<GetAppIcon style={{ width: 20 }} />
				</Button>
			</div>
		</div>
	);
};

EditorLeftPanelURLEbookIntro.propTypes = {
	// subdomain: PropTypes.string
	// openLinkedInDialog: PropTypes.bool.isRequired,
	// setOpenLinkedInDialog: PropTypes.func.isRequired
};

export default EditorLeftPanelURLEbookIntro;
